<template>
    <div>
        <v-expansion-panels class="mb-5" v-model="panel">
            <v-col cols="12" class="mx-0 px-0 my-0 py-0">
                <!-- General Data -->
                <v-row justify="center" align="center">
                    <v-col cols="6" class="pb-1">
                        <v-expansion-panel>
                            <v-expansion-panel-header style="text-transform: uppercase;">
                                <label style="font-size: 16px; font-weight: bold;"
                                    class="blue_accent--text">{{ $t('create_customer.general_data') }}</label>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content class="mt-2">
                                <v-text-field class="py-0" v-model="customer.name"
                                    :label="$t('create_customer.tradename')" :rules="rules_required"></v-text-field>
                                <v-text-field class="py-0" v-model="customer.social_reason"
                                    :label="$t('create_customer.business_name')" :rules="rules_required"></v-text-field>
                                <v-autocomplete class="mt-0 py-0" v-model="customer.is_national" item-text="text"
                                    item-value="value" :items="behaviors"
                                    :label="$t('create_customer.operation_type')"></v-autocomplete>
                                <v-autocomplete class="mt-0 py-0" v-if="customer.is_national != 1"
                                    v-model="customer.country" :items="countries" :label="$t('create_customer.country')"
                                    :rules="rules_required"></v-autocomplete>
                                <v-autocomplete class="mt-0 py-0"
                                    v-if="customer.is_national != 1 && customer.country == 'MX'"
                                    v-model="customer.state" :items="states" :label="$t('create_customer.state')"
                                    :rules="rules_required"></v-autocomplete>
                                <v-autocomplete class="mt-0 py-0"
                                    v-if="customer.is_national != 1 && customer.country == 'MX'"
                                    v-model="customer.municipality" :items="municipalities"
                                    :label="$t('create_customer.municipality')"
                                    :rules="rules_required"></v-autocomplete>
                                <v-text-field class="py-0" v-if="customer.is_national != 1"
                                    v-model="customer.neighborhood" :label="$t('create_customer.neighborhood')"
                                    :rules="rules_required"></v-text-field>
                                <v-text-field class="py-0" v-if="customer.is_national != 1" v-model="customer.street"
                                    :label="$t('create_customer.street')" :rules="rules_required"></v-text-field>

                                <v-row v-if="customer.is_national != 1">
                                    <v-col cols="4" class="py-0">
                                        <v-text-field class="py-0" v-model="customer.zipcode"
                                            :label="$t('create_customer.zip_code')"
                                            :rules="rules_zipcode"></v-text-field>
                                    </v-col>
                                    <v-col cols="4" class="py-0">
                                        <v-text-field class="py-0" v-model="customer.external_number"
                                            :label="$t('create_customer.ext_number')"
                                            :rules="rules_external"></v-text-field>
                                    </v-col>
                                    <v-col cols="4" class="py-0">
                                        <v-text-field class="py-0" v-model="customer.internal_number"
                                            :label="$t('create_customer.int_number')"></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row v-if="customer.is_national != 1">
                                    <v-col cols="6" class="py-0">
                                        <v-text-field class="py-0" v-model="customer.contact_phone" counter="10"
                                            :label="$t('create_customer.contact_phone')"
                                            :rules="rules_phone"></v-text-field>
                                    </v-col>
                                    <v-col cols="6" class="py-0">
                                        <v-text-field class="py-0" v-model="customer.service_phone" counter="10"
                                            :label="$t('create_customer.customer_service_phone')"></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-text-field class="py-0" v-model="customer.email" :label="$t('create_customer.email')"
                                    :rules="email_rules"></v-text-field>

                                <v-row v-if="customer.is_national != 1">
                                    <v-col cols="6" class="py-0">
                                        <v-text-field class="py-0" v-model="customer.immex_ssn"
                                            :label="$t('create_customer.immex')"></v-text-field>
                                    </v-col>
                                    <v-col cols="6" class="py-0">
                                        <v-text-field class="py-0" v-model="customer.rfe_idc"
                                            :label="$t('create_customer.rfe')"></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12" class="py-0">
                                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                                            <v-col cols="12" class="py-0" style="display:flex">
                                                <v-checkbox class="mt-0" color="blue_accent"
                                                    v-model="customer.hd_services"
                                                    :label="$t('create_customer.hd_services_required')"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                                            <v-col cols="12" class="py-0" style="display:flex">
                                                <v-checkbox class="mt-0" color="blue_accent"
                                                    v-model="customer.picking_required"
                                                    :label="$t('create_customer.advanced_picking')"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-col>
                </v-row>

                <!-- Warehouse Data  -->
                <v-row justify="center" align="center">
                    <v-col cols="6" class="pb-1">
                        <v-expansion-panel>
                            <v-expansion-panel-header style="text-transform: uppercase;">
                                <label style="font-size: 16px; font-weight: bold;"
                                    class="blue_accent--text">{{ $t('create_customer.warehouse') }}</label>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content class="mt-2">
                                <v-row justify="center" align="center">
                                    <v-col cols="12" class="py-0">
                                        <v-row class="px-0 py-0 my-0" justify="start" align="start">
                                            <v-col cols="6" class="py-0" style="display:flex"
                                                v-for="(warehouse, i) of customer.warehouses" :key="i">
                                                <v-checkbox class="mt-0" color="blue_accent" v-model="warehouse.value"
                                                    :label="warehouse.name"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-col>
                </v-row>

                <!-- RFID -->
                <v-row justify="center" align="center">
                    <v-col cols="6" class="pb-1">
                        <v-expansion-panel>
                            <v-expansion-panel-header style="text-transform: uppercase;">
                                <label style="font-size: 16px; font-weight: bold;"
                                    class="blue_accent--text">{{ $t('create_customer.rfid_tech') }}</label>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <v-row class="pb-2 my-0" justify="center" align="center">
                                    <v-col cols="8" class="px-3 py-0">
                                        <span>{{ $t('create_customer.is_rfid') }}:</span>
                                    </v-col>
                                    <v-col cols="4" class="px-3 py-0" justify="end" align="end">
                                        <v-btn class="radio-left white--text"
                                            v-bind:color="is_rfid == 0 ? 'blue_accent' : 'grey'"
                                            @click="(is_rfid = 0)">{{ $t('create_customer.no') }}</v-btn>
                                        <v-btn class="radio-right white--text"
                                            v-bind:color="is_rfid == 1 ? 'blue_accent' : 'grey'"
                                            @click="(is_rfid = 1)">{{ $t('create_customer.yes') }}</v-btn>
                                    </v-col>
                                </v-row>
                                <v-row class="pb-2 my-0" justify="center" align="center" v-if="is_rfid == true">
                                    <v-col cols="8" class="px-3 py-0">
                                        <span>{{ $t('create_customer.rfid_by_product') }}:</span>
                                    </v-col>
                                    <v-col cols="4" class="px-3 py-0" justify="end" align="end">
                                        <v-btn class="radio-left white--text"
                                            v-bind:color="customer.rfid_by_product == 0 ? 'blue_accent' : 'grey'"
                                            @click="(customer.rfid_by_product = 0)">{{ $t('create_customer.no')
                                            }}</v-btn>
                                        <v-btn class="radio-right white--text"
                                            v-bind:color="customer.rfid_by_product == 1 ? 'blue_accent' : 'grey'"
                                            @click="(customer.rfid_by_product = 1)">{{ $t('create_customer.yes')
                                            }}</v-btn>
                                    </v-col>
                                </v-row>
                                <v-row class="py-0 my-0" justify="center" align="center" v-if="is_rfid == true">
                                    <v-col cols="12" class="py-0">
                                        <label>{{ $t('create_customer.warehouse_rfid') }}</label>
                                    </v-col>
                                </v-row>
                                <v-row class="py-0 my-0" justify="center" align="center" v-if="is_rfid == true">
                                    <v-col cols="12" class="py-0">
                                        <v-row class="px-0 py-0 my-0" justify="start" align="start">
                                            <v-col cols="6" class="py-0" style="display:flex"
                                                v-for="(warehouse, i) of customer.warehouses" :key="i">
                                                <v-checkbox class="mt-0" color="blue_accent"
                                                    v-if="warehouse.value == true" v-model="warehouse.is_rfid"
                                                    :label="warehouse.name"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-col>
                </v-row>

                <!-- Guides Service -->
                <v-row justify="center" align="center">
                    <v-col cols="6" class="pb-1">
                        <v-expansion-panel>
                            <v-expansion-panel-header style="text-transform: uppercase;">
                                <label style="font-size: 16px; font-weight: bold;"
                                    class="blue_accent--text">{{ $t('create_customer.guides_service') }}</label>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <v-row class="pb-2 my-0" justify="center" align="center">
                                    <v-col cols="8" class="px-3 py-0">
                                        <span>{{ $t('create_customer.guides_service_required') }}:</span>
                                    </v-col>
                                    <v-col cols="4" class="px-3 py-0" justify="end" align="end">
                                        <v-btn class="radio-left white--text"
                                            v-bind:color="customer.guides_service == 0 ? 'blue_accent' : 'grey'"
                                            @click="(customer.guides_service = 0)">{{ $t('create_customer.no')
                                            }}</v-btn>
                                        <v-btn class="radio-right white--text"
                                            v-bind:color="customer.guides_service == 1 ? 'blue_accent' : 'grey'"
                                            @click="(customer.guides_service = 1)">{{ $t('create_customer.yes')
                                            }}</v-btn>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-col>
                </v-row>

                <!-- Fullfillment -->
                <v-row justify="center" align="center">
                    <v-col cols="6" class="pb-1">
                        <v-expansion-panel>
                            <v-expansion-panel-header style="text-transform: uppercase;">
                                <label style="font-size: 16px; font-weight: bold;"
                                    class="blue_accent--text">{{ $t('create_customer.fulfillment') }}</label>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <v-row class="pb-2 my-0" justify="center" align="center">
                                    <v-col cols="8" class="px-3 py-0">
                                        <span>{{ $t('create_customer.client_fulfillment') }}:</span>
                                    </v-col>
                                    <v-col cols="4" class="px-3 py-0" justify="end" align="end">
                                        <v-btn class="radio-left white--text"
                                            v-bind:color="customer.fulfillment == 0 || customer.fulfillment == 'none' ? 'blue_accent' : 'grey'"
                                            @click="customer.fulfillment = 'none'">{{ $t('create_customer.no')
                                            }}</v-btn>
                                        <v-btn class="radio-right white--text"
                                            v-bind:color="customer.fulfillment != 0 && customer.fulfillment != 'none' ? 'blue_accent' : 'grey'"
                                            @click="customer.fulfillment = 1">{{ $t('create_customer.yes') }}</v-btn>
                                    </v-col>
                                </v-row>
                                <v-row class="py-0 my-0" justify="center" align="center"
                                    v-if="customer.fulfillment != 0 && customer.fulfillment != 'none'">
                                    <v-col cols="12" class="py-0">
                                        <label>{{ $t('create_customer.select_fulfillment') }}</label>
                                    </v-col>
                                </v-row>
                                <v-row class="py-0 my-0" justify="center" align="center"
                                    v-if="customer.fulfillment != 0 && customer.fulfillment != 'none'">
                                    <v-col cols="12" class="py-0">
                                        <v-radio-group class="my-0" v-model="customer.fulfillment">
                                            <v-radio v-for="t of fullfillment_types" color="blue_accent" :key="t.label"
                                                :label="t.label" :value="t.value"></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                                <v-row class="py-0 mt-3 mb-1" justify="center" align="center"
                                    v-if="customer.fulfillment != 0 && customer.fulfillment != 'none'">
                                    <v-col cols="12" class="py-0">
                                        <label>{{ $t('create_customer.select_shipping_services') }}</label>
                                    </v-col>
                                </v-row>

                                <!-- ADDING SMART OPTION -->
                                <v-row class="py-0 my-0" justify="center" align="center"
                                    v-if="customer.fulfillment != 0 && customer.fulfillment != 'none'">
                                    <v-col cols="12" class="py-0">
                                        <v-row class="px-0 py-0 my-0" justify="start" align="start">
                                            <v-col cols="6" class="py-0" style="display:flex" v-for="(ss, i) of [smart]"
                                                :key="i">
                                                <v-checkbox class="mt-0" color="blue_accent"
                                                    :disabled="customer.country != 'MX'" v-model="ss.value"
                                                    :label="ss.name"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>

                                <!-- ADDING SHIPPING ACCOUNTS OPTIONS -->
                                <v-row class="py-0 my-0" justify="center" align="center"
                                    v-if="customer.fulfillment != 0 && customer.fulfillment != 'none' && customer.shipping_accounts.length > 0">
                                    <v-col cols="12" class="py-0">
                                        <v-row class="px-0 py-0 my-0" justify="start" align="start">
                                            <v-col cols="6" class="py-0" style="display:flex"
                                                v-for="(ss, i) of customer.shipping_accounts" :key="i">
                                                <v-checkbox class="mt-0" color="blue_accent" v-model="ss.value"
                                                    :disabled="smart.value" :label="ss.name"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>

                                <span v-if="smart.value && states.length > 0">

                                    <v-row class="py-0 mt-3 mb-1" justify="center" align="center"
                                        v-if="customer.fulfillment != 0">
                                        <v-col cols="12" class="py-0">
                                            <label>{{ $t('create_customer.select_priority') }}</label>
                                        </v-col>
                                    </v-row>

                                    <v-row class="py-0 mt-3 mb-1" justify="center" align="center"
                                        v-if="customer.fulfillment != 0">
                                        <v-col cols="12" class="py-0">
                                            <v-checkbox class="mt-0" color="blue_accent" v-model="smart.same_value"
                                                :label="$t('create_customer.same_priority')"></v-checkbox>
                                        </v-col>
                                    </v-row>
                                    <v-row v-for="state of smart_states" :key="state" class="pt-1 my-0">
                                        <v-col cols="5" class="py-0 my-0">{{ state }}</v-col>
                                        <v-col cols="7">
                                            <v-row>
                                                <v-col cols="4" class="py-0 my-0">
                                                    <v-autocomplete class="mt-0 py-0 autocomplete-label" append-icon=""
                                                        flat solo hide-details
                                                        style="max-height: 20px; min-height: 20px;"
                                                        v-model="smart_values[state].option_1"
                                                        :items="shipping_services"
                                                        :label="$t('create_customer.option1')"></v-autocomplete>
                                                </v-col>
                                                <v-col cols="4" class="py-0 my-0">
                                                    <v-autocomplete class="mt-0 py-0 autocomplete-label" append-icon=""
                                                        flat solo hide-details
                                                        style="max-height: 20px; min-height: 20px;"
                                                        v-model="smart_values[state].option_2"
                                                        :items="shipping_services"
                                                        :label="$t('create_customer.option3')"></v-autocomplete>
                                                </v-col>
                                                <v-col cols="4" class="py-0 my-0">
                                                    <v-autocomplete class="mt-0 py-0 autocomplete-label" append-icon=""
                                                        flat solo hide-details
                                                        style="max-height: 20px; min-height: 20px;"
                                                        v-model="smart_values[state].option_3"
                                                        :items="shipping_services"
                                                        :label="$t('create_customer.option3')"></v-autocomplete>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </span>

                                <v-row class="pb-2 mt-4" justify="center" align="center"
                                    v-if="customer.fulfillment != 0">
                                    <v-col cols="8" class="px-3 py-0">
                                        <span>{{ $t('create_customer.shipments_notifications') }}:</span>
                                    </v-col>
                                    <v-col cols="4" class="px-3 py-0" justify="end" align="end">
                                        <v-btn class="radio-left white--text"
                                            v-bind:color="customer.shipments_notifications == 0 ? 'blue_accent' : 'grey'"
                                            @click="customer.shipments_notifications = 0">{{ $t('create_customer.no')
                                            }}</v-btn>
                                        <v-btn class="radio-right white--text"
                                            v-bind:color="customer.shipments_notifications == 1 ? 'blue_accent' : 'grey'"
                                            @click="customer.shipments_notifications = 1">{{ $t('create_customer.yes')
                                            }}</v-btn>
                                    </v-col>
                                </v-row>
                                <v-row class="py-0 my-0" justify="center" align="center"
                                    v-if="customer.fulfillment != 0">
                                    <v-col cols="12" class="py-0">
                                        <v-checkbox class="mt-0" color="blue_accent"
                                            v-model="customer.avoid_validations"
                                            :label="$t('create_customer.avoid_validations')"></v-checkbox>
                                    </v-col>
                                </v-row>

                                <v-row class="pb-2 mt-4" justifi="center" align="center"
                                    v-if="customer.fulfillment != 0">
                                    <v-col cols="6" class="px-3 py-0">
                                        <span>{{ $t('create_customer.select_cutoff_time') }}:</span>
                                    </v-col>
                                    <v-col cols="6" class="px-3 py-0" justify="end" align="end">

                                        <v-menu ref="cutoff_time" v-model="modal_cutoff_time"
                                            :close-on-content-click="false" :return-value.sync="customer.cutoff_time"
                                            transition="scale-transition" offset-y min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field v-model="customer.cutoff_time"
                                                    :label="$t('create_customer.cutoff_time')"
                                                    append-outer-icon="schedule" readonly v-on="on"></v-text-field>
                                            </template>
                                            <template>
                                                <v-time-picker v-model="customer.cutoff_time" ampm-in-title
                                                    color="blue_accent">
                                                    <v-col justify="space-around" align="center">
                                                        <v-btn text color="red" @click="modal_cutoff_time = false">{{
                                                            $t('create_customer.cancel') }}</v-btn>
                                                        <v-btn text color="blue_accent"
                                                            @click="$refs.cutoff_time.save(customer.cutoff_time)">{{
                                                            $t('create_customer.accept') }}</v-btn>
                                                    </v-col>
                                                </v-time-picker>
                                            </template>
                                        </v-menu>

                                    </v-col>
                                </v-row>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-col>
                </v-row>

                <!-- Notifications -->
                <v-row justify="center" align="center">
                    <v-col cols="6" class="pb-1">
                        <v-expansion-panel>
                            <v-expansion-panel-header style="text-transform: uppercase;">
                                <label style="font-size: 16px; font-weight: bold;"
                                    class="blue_accent--text">{{ $t('create_customer.notifications') }}</label>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <v-row class="pb-2 mt-2" justify="center" align="center">
                                    <v-col cols="8" class="px-3 py-0">
                                        <span>{{ $t('create_customer.operation_notifications') }}:</span>
                                    </v-col>
                                    <v-col cols="4" class="px-3 py-0" justify="end" align="end">
                                        <v-btn class="radio-left white--text"
                                            v-bind:color="customer.operation_notifications == false ? 'blue_accent' : 'grey'"
                                            @click="customer.operation_notifications = false; $forceUpdate()">{{
                                            $t('create_customer.no') }}</v-btn>
                                        <v-btn class="radio-right white--text"
                                            v-bind:color="customer.operation_notifications == true ? 'blue_accent' : 'grey'"
                                            @click="customer.operation_notifications = true; $forceUpdate()">{{
                                            $t('create_customer.yes') }}</v-btn>
                                    </v-col>
                                </v-row>
                                <v-row class="py-0 my-0 mt-2" justify="center" align="center">
                                    <v-col cols="12" class="py-0">
                                        <v-combobox v-model="customer.email_to_notify"
                                            v-if="customer.operation_notifications == true"
                                            :label="$t('create_customer.email_to_notify')" small-chips clearable
                                            :rules="multiple_email_rules" :delimiters="[',', ' ']" multiple
                                            class="py-0 mt-4">
                                            <template v-slot:selection="data">
                                                <v-chip :input-value="data.selected" close label
                                                    @input="remove(data.item)">
                                                    <strong>{{ data.item }}</strong>&nbsp;
                                                </v-chip>
                                            </template>
                                        </v-combobox>
                                    </v-col>
                                </v-row>
                                <v-row class="py-0 mt-3 mb-1" justify="center" align="center"
                                    v-if="customer.operation_notifications == true">
                                    <v-col cols="8" class="py-0">
                                        <label>{{ $t('create_customer.select_language') }}</label>
                                    </v-col>

                                    <v-col cols="4" class="px-3 py-0" justify="end" align="end">
                                        <v-btn class="radio-left white--text"
                                            v-bind:color="customer.language == 'es' ? 'blue_accent' : 'grey'"
                                            @click="customer.language = 'es'">{{ $t('create_customer.es') }}</v-btn>
                                        <v-btn class="radio-right white--text"
                                            v-bind:color="customer.language == 'en' ? 'blue_accent' : 'grey'"
                                            @click="customer.language = 'en'">{{ $t('create_customer.en') }}</v-btn>
                                    </v-col>
                                </v-row>

                                <v-row class="py-0 mt-3 mb-1" justify="center" align="center"
                                    v-if="customer.operation_notifications == true">
                                    <v-col cols="12" class="py-0">
                                        <label>{{ $t('create_customer.select_stepts') }}</label>
                                    </v-col>
                                </v-row>

                                <v-row class="py-0 my-0" justify="center" align="center"
                                    v-if="customer.operation_notifications == true">
                                    <v-col cols="12" class="py-0">
                                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                                            <v-col cols="12" class="py-0" style="display:flex">
                                                <v-checkbox class="mt-0" color="blue_accent"
                                                    v-model="customer.arrival_ad"
                                                    :label="$t('create_customer.create')"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                                            <v-col cols="12" class="py-0" style="display:flex">
                                                <v-checkbox class="mt-0" color="blue_accent"
                                                    v-model="customer.in_out_ad"
                                                    :label="$t('create_customer.on_premises')"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                                            <v-col cols="12" class="py-0" style="display:flex">
                                                <v-checkbox class="mt-0" color="blue_accent"
                                                    v-model="customer.ramping_ad"
                                                    :label="$t('create_customer.ramping')"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                                            <v-col cols="12" class="py-0" style="display:flex">
                                                <v-checkbox class="mt-0" color="blue_accent"
                                                    v-model="customer.start_process_ad"
                                                    :label="$t('create_customer.in_process')"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                                            <v-col cols="12" class="py-0" style="display:flex">
                                                <v-checkbox class="mt-0" color="blue_accent"
                                                    v-model="customer.end_process_ad"
                                                    :label="$t('create_customer.end_process')"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                                            <v-col cols="12" class="py-0" style="display:flex">
                                                <v-checkbox class="mt-0" color="blue_accent"
                                                    v-model="customer.exit_truck_ad"
                                                    :label="$t('create_customer.end_operation')"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                                            <v-col cols="12" class="py-0" style="display:flex">
                                                <v-checkbox class="mt-0" color="blue_accent"
                                                    v-model="customer.outcome_confirmation_ad"
                                                    :label="$t('create_customer.outcome_confirmation_ad')"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>

                                <!-- Reports -->
                                <v-row class="py-0 mt-3 mb-1" justify="center" align="center"
                                    v-if="customer.operation_notifications == true">
                                    <v-col cols="12" class="py-0">
                                        <label>{{ $t('create_customer.select_reports') }}</label>
                                    </v-col>
                                </v-row>
                                <v-row class="py-0 my-0" justify="center" align="center"
                                    v-if="customer.operation_notifications == true">
                                    <v-col cols="12" class="py-0">
                                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                                            <v-col cols="8" class="py-0" style="display:flex">
                                                <v-checkbox class="mt-0" color="blue_accent"
                                                    v-model="customer.operations_by_customer_ad"
                                                    :label="$t('create_customer.operations')"></v-checkbox>
                                            </v-col>
                                            <v-col cols="4" class="py-0">
                                                <v-autocomplete class="mt-0 py-0"
                                                    v-model="customer.operations_by_customer_time" item-text="label"
                                                    item-value="value" :items="frequencies"
                                                    :label="$t('create_customer.frequency')"></v-autocomplete>
                                            </v-col>
                                        </v-row>
                                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                                            <v-col cols="8" class="py-0" style="display:flex">
                                                <v-checkbox class="mt-0" color="blue_accent" v-model="customer.stock_ad"
                                                    :label="$t('create_customer.stock')"></v-checkbox>
                                            </v-col>
                                            <v-col cols="4" class="py-0">
                                                <v-autocomplete class="mt-0 py-0" v-model="customer.stock_time"
                                                    item-text="label" item-value="value" :items="frequencies"
                                                    :label="$t('create_customer.frequency')"></v-autocomplete>
                                            </v-col>
                                        </v-row>
                                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                                            <v-col cols="12" class="py-0" style="display:flex">
                                                <v-checkbox class="mt-0" color="blue_accent"
                                                    v-model="customer.storage_policies_ad"
                                                    :label="$t('create_customer.storage_policies')"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                        <v-row class="px-0 py-0 my-0" justify="center" align="center">
                                            <v-col cols="12" class="py-0" style="display:flex">
                                                <v-checkbox class="mt-0" color="blue_accent"
                                                    v-model="customer.prepared_orders_ad"
                                                    :label="$t('create_customer.prepared_orders_ad')"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-col>
                </v-row>
            </v-col>
        </v-expansion-panels>
    </div>
</template>

<script>
import { getCountriesUseCase } from '../contexts/shared/application/use_cases/get_countries_use_case';
import { getStatesFromCountryUseCase } from '../contexts/shared/application/use_cases/get_states_from_country_use_case';
import { getCitiesFromState } from '../contexts/shared/application/use_cases/get_cities_from_state_use_case';
import { HttpAddressLocationsRepository } from '../contexts/shared/infrastructure/repositories/address_locations_repository';

export default {
    computed: {
        rules_required() { return [v => !!v || this.$t('create_appointment.validations.required_field')] },
        rules_phone() {
            return [
                v => !!v || this.$t('create_appointment.validations.required_field'),
                v => /^(|\d)+$/.test(v) || this.$t('create_customer.validations.phone_format'),
                v => (v && v.length <= 12) || this.$t('create_customer.validations.phone_max_lenght'),
                v => (v && v.length >= 10) || this.$t('create_customer.validations.phone_min_lenght'),
            ]
        },
        rules_zipcode() {
            return [
                v => !!v || this.$t('create_appointment.validations.required_field'),
                v => (v && v.length == 5) || this.$t('create_customer.validations.zipcode_lenght'),
                v => /^(|\d)+$/.test(v) || this.$t('create_customer.validations.zipcode_format'),
            ]
        },
        rules_external() {
            return [
                v => !!v || this.$t('create_appointment.validations.required_field'),
                v => (v && v.length <= 5) || this.$t('create_customer.validations.zipcode_lenght'),
                v => /^(|\d)+$/.test(v) || this.$t('create_customer.validations.zipcode_format'),
            ]
        },
        email_rules() {
            return [
                v => v.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) || this.$t('create_customer.validations.email')
            ]
        },
        multiple_email_rules() {
            return [
                v => {
                    for (let i = 0; i < v.length; i++) {
                        if (!(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(v[i]))) {
                            return this.$t('create_customer.validations.email');
                        }
                    }
                }
            ]
        }
    },
    props: [
        'customer',
        'smart_values',
        'smart_states',
        'smart_loaded'
    ],
    data() {
        return {
            countries: [],
            states: [],
            municipalities: [],
            countries_load: false,
            states_load: false,
            municipalities_load: false,
            modal_cutoff_time: false,
            frequencies: [
                { label: this.$t("create_customer.everyday"), value: "1" },
                { label: this.$t("create_customer.fridays"), value: "2" },
                { label: this.$t("create_customer.end_of_month"), value: "3" },
            ],
            is_rfid: false,
            operation_notifications: 0,
            fulfillment: 0,
            fullfillment_types: [
                { label: this.$t("create_customer.cod"), value: 1 },
                { label: this.$t("create_customer.regulars"), value: 2 },
                { label: this.$t("create_customer.both"), value: 3 }
            ],
            behaviors: [
                { text: this.$t('edit_customer.national_operation'), value: 1 },
                { text: this.$t('edit_customer.international_operation'), value: 0 },
                { text: this.$t('edit_customer.both_operation'), value: 2 }
            ],
            panel: 0,
            smart: { name: "SMART", value: false, same_value: false },
            shipping_services: ["AFIMEX", "FEDEX", "QUALITYPOST"],
        }
    },
    mounted() {
        this.index();
    },
    methods: {
        async index() {
            this.customer.country = "MX";

            try {
                const response = await getCountriesUseCase(HttpAddressLocationsRepository);

                this.countries = response;
            } catch (e) {
                this.displayError(e);
            }

            if (this.customer.rfid_by_product == true) this.is_rfid = true;
            this.$forceUpdate();
        },
        displayError(e) {
            console.log(e);
            this.snackbar = {
                visible: true,
                color: 'error',
                text: e.response == null ? e : e.response.data.fault.message
            }
        },
        showConsole() {
            console.log(this.customer.warehouses)
        }
    },
    watch: {
        "customer.country": async function () {
            if (this.customer.country != "MX") this.smart.value = false;
            this.states = [];
            this.states_load = true;

            try {
                const response = await getStatesFromCountryUseCase(this.customer.country, HttpAddressLocationsRepository);
                this.states = response;

                this.states_load = false;
            } catch (e) {
                this.displayError(e);
            }
        },
        "customer.state": async function () {
            this.municipalities = [];
            this.municipalities_load = true;

            try {
                const response = await getCitiesFromState(this.customer.country, this.customer.state, HttpAddressLocationsRepository);
                this.municipalities = response.map(x => {
                    return x.text;
                });

                this.municipalities_load = false;
            } catch (e) {
                this.displayError(e);
            }
        },
        'smart.same_value': function () {
            if (this.smart_values != {}) {
                if ((this.smart_values.Aguascalientes.option_1 == "" || this.smart_values.Aguascalientes.option_2 == "" || this.smart_values.Aguascalientes.option_3 == "") && this.smart.same_value == true) {
                    this.smart.same_value = false;
                }
                else if ((this.smart_values.Aguascalientes.option_1 != "" && this.smart_values.Aguascalientes.option_2 != "" && this.smart_values.Aguascalientes.option_3 != "") && this.smart.same_value == true) {
                    for (var i in this.smart_values) {
                        this.smart_values[i].option_1 = this.smart_values.Aguascalientes.option_1;
                        this.smart_values[i].option_2 = this.smart_values.Aguascalientes.option_2;
                        this.smart_values[i].option_3 = this.smart_values.Aguascalientes.option_3;
                    }
                }
            }
        },
        'smart_loaded': function () {
            if (this.smart_loaded) this.smart.value = true;
        }
    }
}
</script>

<style></style>